import {MassCampaignStatusEnum} from '@/services/api-clients';

export function massCampaignStatusIconFilter(status: MassCampaignStatusEnum): string {
  switch (status) {
    case MassCampaignStatusEnum.Waiting: return 'mdi-clock-outline';
    case MassCampaignStatusEnum.Approved: return 'mdi-check';
    case MassCampaignStatusEnum.Pending: return 'mdi-sync';
    case MassCampaignStatusEnum.Executed: return 'mdi-checkbox-marked-circle-outline';
  }
}
